var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnualTurnover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clone page",
    clipPath: "url(#clip0_59_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    transform: "translate(-120 -1254)",
    fill: "#FFFBFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inquiry author info"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -377.5,
    width: 399,
    height: 474,
    rx: 19.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip1_59_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24.5V22.625C14.7045 22.625 17.2471 21.5718 19.1595 19.6595C21.0718 17.7471 22.125 15.2045 22.125 12.5C22.125 10.691 21.6424 8.91598 20.7295 7.367C20.1728 6.42247 19.466 5.57525 18.6431 4.85905L18.8746 7.50598L17.0068 7.66939L16.5165 2.06577L22.1202 1.57555L22.2836 3.44342L20.0879 3.63552C20.9713 4.44209 21.7342 5.37912 22.3447 6.41497C23.4277 8.25219 24 10.3564 24 12.5C24 15.7053 22.7518 18.7188 20.4853 20.9853C18.2188 23.2518 15.2053 24.5 12 24.5ZM1.87987 23.4245L1.71647 21.5566L3.91209 21.3645C3.02869 20.558 2.26575 19.6209 1.65525 18.5851C0.572344 16.7478 0 14.6436 0 12.5C0 9.29469 1.24823 6.28123 3.51469 4.01469C5.78123 1.74823 8.79469 0.5 12 0.5V2.375C9.29555 2.375 6.75291 3.42819 4.84055 5.34055C2.92819 7.25291 1.875 9.7955 1.875 12.5C1.875 14.309 2.35758 16.084 3.27052 17.633C3.8272 18.5775 4.53398 19.4247 5.35692 20.141L5.12536 17.494L6.99323 17.3306L7.4835 22.9342L1.87987 23.4245ZM12.9375 20H11.0625V18.125C9.25322 18.125 7.78125 16.653 7.78125 14.8438H9.65625C9.65625 15.6192 10.2871 16.25 11.0625 16.25H12.9375C13.7129 16.25 14.3438 15.6192 14.3438 14.8438C14.3438 14.0683 13.7129 13.4375 12.9375 13.4375H11.0625C9.25322 13.4375 7.78125 11.9655 7.78125 10.1562C7.78125 8.34697 9.25322 6.875 11.0625 6.875V5H12.9375V6.875C14.7468 6.875 16.2188 8.34697 16.2188 10.1562H14.3438C14.3438 9.38084 13.7129 8.75 12.9375 8.75H11.0625C10.2871 8.75 9.65625 9.38084 9.65625 10.1562C9.65625 10.9317 10.2871 11.5625 11.0625 11.5625H12.9375C14.7468 11.5625 16.2188 13.0345 16.2188 14.8438C16.2188 16.653 14.7468 18.125 12.9375 18.125V20Z",
    fill: "#4D2481"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    fill: "white",
    transform: "translate(-120 -1254)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualTurnover);
export default __webpack_public_path__ + "static/media/annual-turnover.0d63d2cd3d6857c83e1bf7e1205014b7.svg";
export { ForwardRef as ReactComponent };